import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-share-icon',
  templateUrl: './files-share.component.html'
})
export class FilesShareComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
